module.exports = __webpack_public_path__ + "media/images/secondary_early_careers/computing_hubs-5a85b19441b6b869d2bf63e39075afb7.svg";